import React from 'react';

import {dashboardBg, waveOne, waveSvg, waveThree, waveTwo} from '../dashboard.module.styl';

export const WaveBackground: React.FC = () => (
    <div className={dashboardBg}>
        <svg className={waveSvg} viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
            <path className={waveOne} d="M -100 350 C 400 290, 1000 70, 1540 -20 L 1540 160 C 1000 250, 400 470, -100 530 Z"/>
            <path className={waveTwo} d="M -100 530 C 400 470, 1000 250, 1540 160 L 1540 340 C 1000 430, 400 650, -100 710 Z"/>
            <path className={waveThree} d="M -100 710 C 400 650, 1000 430, 1540 340 L 1540 520 C 1000 610, 400 830, -100 890 Z"/>
        </svg>
    </div>
);
